/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {ButtonBase, Drawer, Grid, IconButton, Typography} from "@mui/material";
import logo from '../../Recursos/logo_completo.svg'
import logo_blanco from '../../Recursos/logo_blanco.svg'
import {Close, Menu} from '@mui/icons-material'
import {GRADIENTE, SECCIONES} from "../../Constantes";
import {useState} from "react";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {useNavigate} from "react-router-dom";

const BarraCell = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);


    const irRuta = (secc) => {

        switch (secc) {
            case SECCIONES[1]:
                navigate('/Testimonios');
                break
            case SECCIONES[0]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('sistema')
                }, 500)
                break
            case SECCIONES[2]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('calendario')
                }, 500)
                break
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 3, py: 2}}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                <img src={logo} width={190} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <IconButton
                    onClick={() => setOpen(!open)}
                    sx={{background: GRADIENTE, borderRadius: 1}}>
                    <Menu sx={{fill: '#fff'}}/>
                </IconButton>
            </Grid>


            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>

                    <Grid container size={{xs: 12, ms: 12, md: 12}}>
                        {SECCIONES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'center', marginTop: 2}}>
                                    <ButtonBase
                                        onClick={() => {
                                            setOpen(false)
                                            setTimeout(() => {
                                                irRuta(item)
                                            }, 500)
                                        }}

                                    >
                                        <Typography
                                            sx={{
                                                color: '#fff',
                                                fontSize: 22,
                                                fontWeight: 600,
                                                textAlign: 'center'
                                            }}>{item}</Typography>
                                    </ButtonBase>
                                </Grid>
                            )
                        })}





                    </Grid>


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 60}}>
                        <img src={logo_blanco} width={200} height={'auto'}/>
                    </Grid>




                </Grid>

            </Drawer>


        </Grid>
    )

}
export default BarraCell